import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { Constants } from 'src/app/util/Constants';
import { CommonService } from 'src/app/service/CommonService';
@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html'
})

export class EmailVerifyComponent extends BaseComponent implements OnInit {
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
  evForm: FormGroup;
  restSub: Subscription;
  submitted: boolean = false;
  user: User;
  sessionUser: string;
  menuType: string;
  resendDisabled: boolean = false;
  pageMsgRendered: boolean;
  resourceUrl;


  appErrorPrefix: string = "bss.api.error";

  constructor(public rest: UserService,
    public progressService: ProgressService,
    injector: Injector,
    public commonService: CommonService,
  ) {
    super(injector);
    this.menuService.setDisplayStatusByMenuType("noauth");
    this.sessionUser = sessionStorage.getItem("user");
    this.pageMsgRendered = false;
  }

  ngOnInit(): void {
    this.evForm = new FormGroup({
      pin: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(Constants.P_NUMBERS_ONLY),
      Validators.minLength(8), Validators.maxLength(8)])),
    });

    this.sessionUser = sessionStorage.getItem("user");
    const user = JSON.parse(this.sessionUser);
    this.menuType = (user != null) ? "secure" : "public";

    this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("email-verify-send-email:" + JSON.stringify(response));
      if (response.result == 1) {
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
      }
    }, (error) => { this.processError(error) });

  }

  getUserFromSession(sessionUser: string): User {

    this.user = JSON.parse(sessionUser);

    /*
    if (!this.user) {
      this.appError = true;
      this.appErrorMessage = this.getMessage(this.appErrorPrefix + ".-1");
      console.error("Unable to retreive user's profile");
      return null;
    } */

    if (!this.user) {
      //Routing to the Error page as the session information is not available
      this.router.navigate(['/public/error']);
      return null;
    }
    return this.user;
  }

  onSubmit(): void {
    this.submitted = true;

    this.appSuccess = false;
    this.appError = false;
    console.log('Entered OTP: ', this.evForm.get('pin').value);
    this.user = this.getUserFromSession(this.sessionUser);
    this.pageMsgRendered = false;

    if (this.evForm.valid) {
      this.isSubmitting = true;
      this.user.otp = this.evForm.get("pin").value;
      console.log("User values: ", this.user);

      // Verify whether OTP entered matches - 
      this.progressService.open();
      this.restSub = this.rest.validateEmailMFA(this.user).subscribe(response => {
        console.log("get-data:" + JSON.stringify(response));
        this.isSubmitting = false;
        if (response.result == 1) {
          this.appError = true;
          this.progressService.close();
          this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);

          if (response.error_code === 10 || response.error_code === 11) {
            this.resendDisabled = true;
          }
        }
        else {
          this.appError = false;

          // If resource_url is not null, then route the user to that page
          this.route.queryParams.subscribe(params => {
            const fullResourceUrl = (params['resource_url'])?.trim() ?? sessionStorage.getItem("resource_url");
            console.log("fullResourceUrl: " + fullResourceUrl);

            // if resource url received then search of the resource_url within this string
            this.resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
            console.log("this.resourceUrl: " + this.resourceUrl);

            this.mapResourceURL(this.resourceUrl);
          });

          const sessionUser = sessionStorage.getItem("user");
          if (sessionUser) {
            let user: User = JSON.parse(sessionUser);
            user.emailVerified = "true";
            sessionStorage.setItem("user", JSON.stringify(user));
          }
          setTimeout(()=>{
            this.router.navigate(['secure/emailVerify/success']);
            this.progressService.close();
          },2000);
          
          
        }
      }, (error) => {
        this.processError(error);
        this.progressService.close();
      },
        () => {
          
        }
      );
    }
  }

  // make an api call to retrieve the mfa url
  mapResourceURL(signinURL: string) {
    if (signinURL) {
      signinURL = decodeURIComponent(signinURL);
      this.commonService.getURL(signinURL).subscribe(response => {
        console.log("get-sigin-url:" + JSON.stringify(response));
        if (response.result == 1) {
          this.appError = true;
          this.appErrorMessage = this.getMessage(null);
        } else {
          this.appError = false;
          this.resourceUrl = response.usermfaURL;
          sessionStorage.setItem("resource_url", this.resourceUrl);
          console.log("resource_url: [" + this.resourceUrl + "]");
        }
      });
    }
    return signinURL;
  }


  onResend(): void {
    this.submitted = false;
    //console.log(this.otpForm);
    this.evForm.setValue({ pin: '' });
    this.pageMsgRendered = false;

    this.resendDisabled = true;
    this.progressService.open();
    this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("send-email:" + JSON.stringify(response));
      if (response.result > 0) {
        this.appError = true;
        this.appSuccess = false;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = "bss.user.email.update.otp.sent.success";
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      }
    );

    setTimeout(() => {
      this.resendDisabled = false;
    }, 60000);

  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

}